import i18next from 'i18next'
import { AsyncState, Updater, unloadedAsyncState } from 'widgets-for-react'
import { loadKnowledgeTeasers } from '../knowledgeTeasers/knowledgeTeasersApi'
import { KnowledgeTeasersData } from '../knowledgeTeasers/knowledgeTeasersState'
import {
  getKnowledgeTypeSectionOfSlug,
  knowledgeTypes,
} from '../knowledgeUtils'
import { getKnowledgeTypeOverviewData } from './knowledgeTypeOverviewApi'

export type KnowledgeTypeOverviewState = {
  knowledgeTypeOverviewData: AsyncState<KnowledgeTeasersData>
}

export const initialKnowledgeTypeOverviewState = (
  type: string
): KnowledgeTypeOverviewState => {
  const knowledgeType = knowledgeTypes.find(
    (knowledgeType) =>
      (i18next.language == 'en'
        ? getKnowledgeTypeSectionOfSlug(knowledgeType).en
        : getKnowledgeTypeSectionOfSlug(knowledgeType).nl) === type
  )
  return knowledgeType
    ? {
        knowledgeTypeOverviewData: loadKnowledgeTeasers(() =>
          getKnowledgeTypeOverviewData(knowledgeType)
        ),
      }
    : {
        knowledgeTypeOverviewData: unloadedAsyncState(),
      }
}

export const knowledgeTypeOverviewStateUpdaters = {
  knowledgeTypeOverviewDataUpdater:
    (updater: Updater<AsyncState<KnowledgeTeasersData>>) =>
    (currentState: KnowledgeTypeOverviewState): KnowledgeTypeOverviewState => ({
      ...currentState,
      knowledgeTypeOverviewData: updater(
        currentState.knowledgeTypeOverviewData
      ),
    }),
}
